import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { LayoutService } from '../services/layout.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { OfflineBanner } from '../../../shared/ui/offline-banner/offline-banner';

@Component({
  selector: 'app-base-layout',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatProgressBarModule,
    OfflineBanner,
  ],
  templateUrl: './base-layout.html',
  styleUrl: './base-layout.scss',
})
export class BaseLayout {
  readonly layoutService = inject(LayoutService);

  onSyncRequested(): void {
    this.layoutService.requestSync();
  }
}
